import React, { useState, useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import { sessionApiClient } from "@planningcenter/cc-api-client"
import { Icon, Loading } from "source/shared/components"

const HouseholdInviteAcceptance = () => {
  const [searchParams] = useSearchParams()
  const [loading, setLoading] = useState(true)
  const [hasError, setHasError] = useState(false)
  const [error, setError] = useState("")
  const [submitter, setSubmitter] = useState(null)

  useEffect(() => {
    sessionApiClient
      .post("/people/v2/accept_household_invite", {
        data: {
          attributes: {
            _e: searchParams.get("_e"),
          },
        },
      })
      .then((response) => {
        setLoading(false)
        setHasError(false)
        setSubmitter(response.meta.form_submitter_name)
      })
      .catch((e) => {
        setLoading(false)
        setHasError(true)
        setError(e?.errors?.[0]?.detail)
      })
  }, [searchParams])

  const renderErrorMessage = () => {
    return error ? (
      <div className="alert error-alert d-f fd-c ai-c g-1">
        <Icon
          className="fs-0 c-ruby"
          symbol="general#exclamation-triangle"
          aria-hidden
        />
        <h2 className="c-ruby">
          There was a problem adding you to this household
        </h2>
        <p className="mb-0">{error}</p>
      </div>
    ) : (
      <div className="alert error-alert d-f fd-c ai-c g-1">
        <Icon
          className="fs-0 c-ruby"
          symbol="general#exclamation-triangle"
          aria-hidden
        />
        <h2 className="c-ruby">Uh oh! That link wasn&#39;t valid.</h2>
        <p className="mb-0">Try copying the link directly from your email.</p>
      </div>
    )
  }

  return loading ? (
    <Loading />
  ) : hasError ? (
    renderErrorMessage()
  ) : (
    <div className="alert success-alert d-f jc-c ai-c g-1">
      <Icon
        className="fs-3 c-emerald"
        symbol="general#check-circle"
        aria-hidden
      />
      <h2>You are now in a household with {submitter}!</h2>
    </div>
  )
}

export default HouseholdInviteAcceptance
